import React from 'react'
import ReactStars from "react-rating-stars-component";



const Review = ({review}) => {
 


  return (
  
    
 <div  class="flex flex-col space-y-4 md:space-y-0 md:flex-row md:space-x-4 w-[350px] md:w-[370px]  ">
      <div class="bg-gray-200 rounded-lg p-8 text-center ">
        <p class="font-bold uppercase">{review.name}</p>
        <p>{review.reviewContent.slice(0 ,90)}</p>
        <div class="flex items-center justify-center space-x-2 mt-4">
       <ReactStars   isSelectable={false}   value={review.star}/>
        </div>
      </div>
 

</div>

  )
}

export default Review
